import { render, staticRenderFns } from "./DownloadModal.vue?vue&type=template&id=3d6015d4&"
import script from "./DownloadModal.vue?vue&type=script&lang=ts&"
export * from "./DownloadModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports